<template>
    <div class="col-2" style="min-width:190px;">
        <div class="card shoplist">
            <slot v-if="product.img">
                <img :src="product.img" :alt="product.name" class="card-img-top" />
            </slot>
            <slot v-if="!product.img">
                <div
                    class="d-flex align-content-center justify-content-center text-center"
                    style="height:107px; width:100%; background:#fafafa"
                >
                    <i
                        class="fas fa-image fa-lg d-flex align-self-center"
                        style="font-size:80px; color:#eeeeee"
                    ></i>
                </div>
            </slot>
            <div class="card-body">
                <h5 class="card-title text-center">{{ product.name }}</h5>
            </div>
            <div class="card-footer">
                <div class="card-text mb-2 d-flex">
                    <small class="flex-fill">
                        <span class="text-muted text-uppercase">{{ product.sku }}</span>
                    </small>
                    <small class="flex-fill text-right">
                        <b>{{ product.price | dollars }}</b>
                    </small>
                </div>
                <div class="card-text text-center">
                    <slot v-for="item in product.inventories">
                        <slot v-if="item.asf_id == repair.asf_id">
                            <a
                                v-if="item.quantity > 0 && item.inventory_type_id == 1 && showButton(product,'from_stock')"
                                href
                                class="badge badge-primary text-uppercase p-1 mb-2 text-wrap w-100"
                                @click.prevent="addToCart(product, item.inventory_type_id)"
                            >
                                <i class="fas fa-cart-plus"></i>
                                {{ $t('part.button.' + item.type_name.toLowerCase().replace(/\s/g, '')) }} ({{ item.quantity }})
                            </a>
                            <a
                                v-if="item.quantity > 0 && item.inventory_type_id == 2 && showButton(product,'early_kit')"
                                href
                                class="badge badge-success text-uppercase text-white p-1 mb-2 text-wrap w-100"
                                @click.prevent="addToCart(product, item.inventory_type_id)"
                            >
                                <i class="fas fa-cart-plus"></i>
                                {{ $t('part.button.' + item.type_name.toLowerCase().replace(/\s/g, '')) }} ({{ item.quantity }})
                            </a>
                            <a
                                v-if="item.quantity > 0 && item.inventory_type_id == 3 && showButton(product,'canabalizacao')"
                                href
                                class="badge badge-dark text-uppercase text-white p-1 mb-2 text-wrap w-100"
                                @click.prevent="addToCart(product, item.inventory_type_id)"
                            >
                                <i class="fas fa-cart-plus"></i>
                                {{ item.type_name }} ({{ item.quantity }})
                            </a>
                        </slot>
                    </slot>
                    <a
                        v-if="showButton(product,'in_warranty')"
                        href
                        class="badge badge-warning text-uppercase text-white p-1 mb-2 text-wrap w-100"
                        @click.prevent="addToCart(product, 0)"
                    >
                        <i class="fas fa-cart-plus"></i>
                        {{$t('part.button.inwarranty')}}
                    </a>
                    <a
                        v-if="showButton(product,'buy')"
                        href
                        class="badge badge-info text-uppercase p-1 text-wrap w-100"
                        @click.prevent="addToCart(product, null)"
                    >
                        <i class="fas fa-cart-plus"></i>
                        {{$t('part.button.buypart')}}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { dollars } from "@/helpers/filters";
import { mapState } from "vuex";

export default {
  name: "item",
  computed: {
    ...mapState("repairs", {
      repair: "repair"
    }),
    roles() {
      return this.$store.getters["auth/getSessionRoles"];
    },
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  props: ["product"],
  filters: {
    dollars
  },
  methods: {
    addToCart(product, inv) {
      this.$store.dispatch("cart/addToCart", { product, inv });
    },
    showButton(item, type) {
      return this.roles.some(r => {
        let role = r.replace("-", "_");

        if (role.includes("asf")) {
          role = "asf";
        }

        if (item.visible.user[role]) {
          try {
            return item.visible.user[role].page[
              "repair_status"
            ].buttons.includes(type);
          } catch (e) {
            return false;
          }
        }
      });
      //   return true;
    }
  }
};
</script>
